import React from 'react';
import ResearchReportsCountyFilter from './filters/ResearchReportsCountyFilter';
import ResearchReportsDistrictFilter from './filters/ResearchReportsDistrictFilter';
import ResearchReportsParishFilter from './filters/ResearchReportsParishFilter';
import ResearchReportsConstituencyFilter from './filters/ResearchReportsConstituencyFilter';
import ResearchReportsRegionFilter from './filters/ResearchReportsRegionFilter';
import ResearchReportsPeriodFilter from './filters/ResearchReportsPeriodFilter';
import ResearchReportsDateRangeFilter from './filters/ResearchReportsDateRangeFilter';
import ResearchReportsAuthorFilter from './filters/ResearchReportsAuthorFilter';
import ResearchReportsKeywordFilter from './filters/ResearchReportsKeywordFilter';
import FormGroup from '../../components/FormGroup';

export default function ResearchReportsSearchFilters() {
  return (
    <>
      <ResearchReportsKeywordFilter />

      <FormGroup title="Location">
        <ResearchReportsCountyFilter />
        <ResearchReportsDistrictFilter />
        <ResearchReportsParishFilter />
        <ResearchReportsConstituencyFilter />
        <ResearchReportsRegionFilter />
      </FormGroup>

      <FormGroup title="Dates">
        <ResearchReportsDateRangeFilter />
        <ResearchReportsPeriodFilter />
      </FormGroup>

      <FormGroup title="Author">
        <ResearchReportsAuthorFilter />
      </FormGroup>
    </>
  );
}
